import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Ressult() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#F15D20" }}>Results</span>
            </h2>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-lg-1"
          >
            <p>
              Select Dealer Service, the digital platform is a reliable, secure,
              contemporary, feature-rich and highly-functional website. With a
              simple interface, we have built an exceptional website where users
              can easily find the information they are looking for and want to
              come back for the user-focused experience.
            </p>
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center"
          >
            <StaticImage
              src="../../../images/case-studies/select-dealer/result_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={2880}
              height={749}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ressult;
